var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('section', {
    staticClass: "hero is-bold is-primary"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Premiação")]), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("OCM " + _vm._s(2024 - _vm.ano))])])])]), _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('article', {}, [_c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', [_vm._v("Alunos premiados cujos nomes estejam seguidos de uma "), _c('b-tag', {
    staticClass: "is-warning"
  }, [_vm._v("etiqueta amarela")]), _vm._v(" foram selecionados para compor as equipes da Olimpíada Rioplatense de Matemática, no nível indicado na etiqueta. Da mesma forma, uma "), _c('b-tag', [_vm._v("etiqueta cinza")]), _vm._v(" indica um(a) suplente do nível correspondente. ")], 1), _c('li', [_vm._v("Os alunos estão dispostos em ordem alfabética.")])])]), _c('b-tabs', {
    model: {
      value: _vm.ano,
      callback: function ($$v) {
        _vm.ano = $$v;
      },
      expression: "ano"
    }
  }, [_c('b-tab-item', {
    attrs: {
      "label": "2024"
    }
  }, [_c('PremiacaoTabela', {
    attrs: {
      "premiados": _vm.premiados.ano2024
    }
  })], 1), _c('b-tab-item', {
    attrs: {
      "label": "2023"
    }
  }, [_c('PremiacaoTabela', {
    attrs: {
      "premiados": _vm.premiados.ano2023
    }
  })], 1), _c('b-tab-item', {
    attrs: {
      "label": "2022"
    }
  }, [_c('PremiacaoTabela', {
    attrs: {
      "premiados": _vm.premiados.ano2022
    }
  })], 1), _c('b-tab-item', {
    attrs: {
      "label": "2021"
    }
  }, [_c('PremiacaoTabela', {
    attrs: {
      "premiados": _vm.premiados.ano2021
    }
  })], 1)], 1)], 1)])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };